var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useState, useEffect } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { Divider, Text } from '..';
import { ChevronDown } from '@olxbr/ds-icons';
import { ChevronUp } from '@olxbr/ds-icons';
import { accordionDefaultProps } from './props';
import * as Styles from './styles';
/**
 * Componente Accordion do Design System OLX
 */
export const Accordion = props => {
  const {
      id,
      icon,
      header,
      description,
      children,
      chevronPosition = accordionDefaultProps.chevronPosition,
      showDescription = accordionDefaultProps.showDescription,
      open = accordionDefaultProps.open,
      disabled = accordionDefaultProps.disabled,
      withBorder = accordionDefaultProps.withBorder,
      onClick
    } = props,
    rest = __rest(props, ["id", "icon", "header", "description", "children", "chevronPosition", "showDescription", "open", "disabled", "withBorder", "onClick"]);
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    disabled ? setShowContent(false) : setShowContent(open);
  }, [open, disabled]);
  const getChevronIcon = showContent => {
    return React.createElement(Styles.IconWrapper, null, showContent ? React.createElement(ChevronUp, {
      "data-testid": "chevron-up-icon"
    }) : React.createElement(ChevronDown, {
      "data-testid": "chevron-down-icon"
    }));
  };
  return React.createElement(Styles.AccordionWrapper, Object.assign({
    "data-ds-component": "DS-Accordion",
    withBorder: withBorder
  }, rest), React.createElement(Styles.HeaderWrapper, {
    "data-ds-component": "DS-Accordion-Button",
    onClick: () => {
      onClick && onClick(!showContent);
      setShowContent(!showContent);
    },
    tabIndex: 0,
    "aria-expanded": showContent,
    "aria-controls": "contentSection".concat(id),
    id: "accordion".concat(id),
    disabled: disabled
  }, chevronPosition === 'left' ? getChevronIcon(showContent) : icon && React.createElement(Styles.IconWrapper, null, icon), React.createElement(Styles.HeaderText, null, React.createElement(Text.SubtitleMedium, {
    weight: "semibold"
  }, header), showDescription && description && React.createElement(Text.BodyMedium, {
    marginTop: "--spacing-1"
  }, description)), chevronPosition === 'right' && getChevronIcon(showContent)), React.createElement(Styles.ContentWrapper, {
    className: showContent ? 'show' : 'hide',
    role: "region",
    id: "contentSection".concat(id),
    "aria-labelledby": "accordion".concat(id)
  }, React.createElement("div", null, React.createElement(Divider, null), React.createElement(Styles.Content, null, children))));
};
Accordion.displayName = 'Accordion';